<template>
  <div id="login">

    <div class="app-container app-theme-white body-tabs-shadow">


      <div>

        <div class="h-100 no-gutters row" v-if="pageIsLoaded">

          <div class="h-100 d-flex justify-content-center align-items-center col-md-8 col-xl-6 mx-auto">

            <div class="w-100 mx-auto bg-white borda-login">

              <div class="mx-auto app-login-box col-sm-12 col-md-11">
                <div class="app-logo"
                     :style="{'background-image':'url('+reportByPartAvailable.account.customLogoDefault+')'}"></div>
                <h4 class="mb-0">
                  <span class="d-block">Download de Relatório</span>
                </h4>
                <h5>{{reportByPartAvailable.descriptionPublic}}</h5>


                <div class="mt-5" style="min-height: 100px">

                  <b-row  v-for="file in files" :key="file.orderList" class="mb-2 d-flex align-content-center justify-content-center">

                      <t-button
                          primary
                          @click="downloadReport(file)" large style="min-width: 300px;">
                        <b-icon-file-pdf v-if="reportByPartAvailable.extension === 'pdf'"></b-icon-file-pdf>
                        <b-icon-file-word v-if="reportByPartAvailable.extension === 'doc' || reportByPartAvailable.extension === 'docx'"></b-icon-file-word>
                        <b-icon-file-excel v-if="reportByPartAvailable.extension === 'xls' || reportByPartAvailable.extension === 'xlsx'"></b-icon-file-excel>
                        {{file.publicFileName}}
                      </t-button>

                  </b-row>


                  <div class="divider row  mt-5"></div>

                  <t-msg info v-if="reportByPartAvailable.extension === 'doc' || reportByPartAvailable.extension === 'docx'">
                    Dica: Para mesclar os arquivos Word, abra a capa do relatório, depois vá para aba 'Inserir' > 'Objeto' (seta para baixo) > 'Texto do Arquivo...'. Por fim escolha os demais arquivos que deseja mesclar.
                  </t-msg>

                  <t-msg info v-if="reportByPartAvailable.extension === 'xls' || reportByPartAvailable.extension === 'xlsx'">
                    Dica: Para mesclar os arquivos Excel, utilize esta ferramenta web: <a href="https://products.aspose.app/cells/pt/merger" target="_blank">Excel Mesclar</a>
                  </t-msg>



                  <div class="d-flex justify-content-center">
                    <div class="row">

                      <a href="https://www.onlaine.com.br" target="_blank" tabindex="-1"
                         class="btn-lg btn btn-link text-focus">
                        Onlaine Tech
                      </a>
                    </div>
                  </div>

                </div>


              </div>

            </div>

          </div>


        </div>


        <div v-else class="d-flex h-100 justify-content-center align-content-center">
          <t-loading/>
        </div>

      </div>
    </div>
  </div>
</template>
<script>
import ui from "@/assets/scripts/ui";
import constants from "@/constants";

export default {
  name: 'ReportByPartPublicFiles',
  metaInfo() {
    return {
      title: "Download de Relatório"
    }
  },
  data() {
    return {
      success: false,
      command: 'insert',
      localStatus: '',
      mode: 'request',
      hasServerError: '',
      formSubmit: false,
      btnSaveClicked: false,
      tokenReport: "",
      tokenDownload: "",
      pageIsLoaded: false,
      path: constants.baseURL + "service/report-by-part-public/",
      reportByPartAvailable: {},
      files:[],
    }
  },
  created() {
    ui.defaultTemplate()
  },
  async mounted() {

    this.tokenReport = this.$route.params.tokenReport
    this.tokenDownload = this.$route.params.tokenDownload

    await this.checkAvailable()


  },
  methods: {


    async checkAvailable() {

      await this.$http.get(this.path + "available/" + this.tokenReport)
          .then(async (response) => {

            this.reportByPartAvailable = response.data

            if (this.reportByPartAvailable.statusReportByPart !== 4) {
              await ui.goPath(this, '/r/' + this.tokenReport)
            }else{

              await this.getFiles()

              this.pageIsLoaded = true


            }


          }).catch(
              error => {
                ui.generalResponseError(this, error)
              }
          )


    },

    async getFiles(){

      await this.$http.get(this.path + "files/" + this.tokenReport + "/"+this.tokenDownload)
          .then(async (response) => {
            this.files = response.data
          }).catch(
              async error => {
                await ui.generalResponseError(this, error, async ()=>{
                  await ui.goPath(this, '/r/' + this.tokenReport)
                })
              }
          )

    },

    async downloadReport(file){

      const data = {
        tokenReport:this.tokenReport,
        tokenDownload:this.tokenDownload,
        orderList:file.orderList
      }

      await this.$http.post(this.path + "download",data,{
        responseType: "blob"
      }).then(async (response) => {

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', file.publicFileName); //or any other extension
            document.body.appendChild(link);
            link.click();

          }).catch(
              error => {
                ui.generalResponseError(this, error)
              }
          )
    }

  }
}
</script>

<style scoped>
@media (max-width: 576px) {
  .h-100{
    height: auto !important;
  }
}


.borda-login {
  border: solid 1px #CCC;
  border-radius: 5px;
  padding-top: 5%;
  padding-bottom: 5%;
  max-width: 800px;
  box-shadow: 0px 0px 15px 15px #FFF;
}

.slide-fade-enter-active {
  transition: all .3s ease;
}

.slide-fade-leave-active {
  transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}

.slide-fade-enter, .slide-fade-leave-to {
  transform: translateX(10px);
  opacity: 0;
}

.icon-stores {
  opacity: 0.7;
  transition: all 300ms;
  width: 100px;
}

.icon-stores:hover {
  opacity: 0.9;
  cursor: pointer;
}

</style>
